export default {
  purchase: state => state.purchase,
  failPurchase : state => state.failPurchase,
  purchaseById : state => state.purchaseById
}
